import { MapPin, Phone, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { StatusBadge } from "./StatusBadge";
import { PRODUCT_TYPES } from "../../constants/config";

const formatTime = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "—";
  }
};

export const ProspectCard = ({ prospect, compact = false }) => {
  const navigate = useNavigate();
  const product = PRODUCT_TYPES.find((p) => p.id === (prospect.interested_product || prospect.interestedProduct));

  return (
    <button
      onClick={() => navigate(`/sales/prospects/${prospect.id}`)}
      data-testid={`prospect-card-${prospect.id}`}
      className="honda-card w-full p-3.5 text-left hover:border-honda-red transition-colors flex items-start gap-3"
    >
      <div className="w-11 h-11 rounded-xl bg-honda-red-light text-honda-red flex items-center justify-center font-heading font-bold text-base flex-shrink-0">
        {prospect.name.split(" ").slice(-1)[0][0]}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <p className="font-heading font-semibold text-sm text-honda-ink truncate">
            {prospect.name}
          </p>
          <StatusBadge status={prospect.status} size="xs" />
        </div>
        <p className="text-[11px] text-honda-muted mt-0.5 flex items-center gap-1">
          <span className="inline-flex items-center gap-0.5">
            <MapPin size={11} /> <span className="truncate max-w-[140px]">{prospect.address}</span>
          </span>
        </p>
        {!compact && (
          <div className="flex items-center gap-3 mt-2 text-[11px] text-honda-muted">
            <span className="flex items-center gap-1">
              <Phone size={11} /> {prospect.phone ? prospect.phone.slice(-9) : "—"}
            </span>
            <span className="flex items-center gap-1">
              <Clock size={11} /> {formatTime(prospect.visited_at || prospect.visitedAt)}
            </span>
          </div>
        )}
        {product && (
          <p className="mt-1.5 inline-block text-[10px] uppercase tracking-wider font-semibold text-honda-red bg-honda-red-light px-1.5 py-0.5 rounded">
            {product.name}
          </p>
        )}
      </div>
    </button>
  );
};
